import React from "react";
import { Flex, Modal, Select, Form, Input, Table, message } from "antd";
import getCurrentShop from "../shop/get-current-shop";

export default () => {
    const [shares, setShares] = React.useState([]);
    const urlParams = new URLSearchParams(window.location.search);
    const shopId = urlParams.get('shopId');
    const [currentShopId, setCurrentShopId] = React.useState(shopId);
    const [levels, setLevels] = React.useState([]);
    const [levelForm] = Form.useForm();
    const [paging, setPaging] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    // 异步获取当前店铺ID
    React.useEffect(() => {
        const fetchShopId = async () => {
            if (!shopId) {
                const currentShop = await getCurrentShop();
                setCurrentShopId(currentShop?.shopId || null);
            }
        };
        fetchShopId();
    }, [shopId]);

    const getShares = async (page = 1) => {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('shopId', shopId || currentShopId);

        const response = await fetch(`/api/salesnet/share-users?${params.toString()}`);
        const result = await response.json();

        if (result && result.success) {
            setShares(result.data.rows);
            setPaging(prev => ({
                ...prev,
                current: page,
                total: result.data.count
            }));
        }
    }

    const getLevelList = async () => { 
        const response = await fetch(`/api/shop/level-user/list`);
        const result = await response.json();

        if(result && result.success) {
            return result.data.map(item => ({label: item.title, value: item.id}));
        }
    }

    const columns = [
        {
            title: '昵称',
            dataIndex: 'username',
        },
        {
            title: '电话',
            dataIndex: 'phoneNo',
        },
        {
            title: '等级',
            dataIndex: 'level',
            render: (text, record) => {
                return text ? text['level.title'] : '';
            }
        },
        {
            title: '累计佣金',
            dataIndex: 'user_share_fund_flows.totalAmount',
            render: (text, record) => {
                return (text || 0)/100;
            }
        },
        {
            fixed: 'right',
            title: '操作',
            render: (text, record) => <a onClick={() => editLevel(record.shopId, record.customerId, record.level['levelId'])}>修改</a>
        }
    ];

    const editLevel = async (shopId, customerId, levelId ) => {
        
        Modal.confirm({
            icon: null,
            title: '修改等级',
            content: (
                <Form form={levelForm}>
                    <Form.Item label="选择等级" name="levelId" layout={'vertical'} required initialValue={levelId}>
                        <Select options={levels} />
                    </Form.Item>
                </Form>
            ),
            onOk() {
                console.log('OK');
                return updateLevel(shopId, customerId, levelForm.getFieldValue('levelId'));
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const updateLevel = async (shopId, customerId, levelId) => { 
        const url = `/api/shop/level-user/level-update`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                shopId,
                customerId,
                levelId
            })
        });
        const result = await response.json();

        if (result && result.success) {
            message.success('修改成功');
            getShares();
        } else {
            message.error(result.data);
        }
    };

    React.useEffect(() => {
        if (currentShopId) {
            getShares();
        }
        getLevelList().then(res => {
            setLevels(res);
        });
    }, [currentShopId]);

    return (
        <div>
            {/* <Input.Search placeholder="请输入店铺名" style={{width: '100%', marginBottom: 10}} /> */}
            {/* <Table rowKey={'partnerId'} size="small" columns={columns} dataSource={partners} /> */}
            <Table 
                rowKey={'customerId'} 
                size="small" 
                columns={columns} 
                dataSource={shares} 
                pagination={{
                    ...paging,
                    onChange: (page) => {
                        getShares(page);
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </div>
    )
};